import React from "react";
import { NotificationTypeJS } from "target_wasm";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import CorporateFareOutlinedIcon from "@mui/icons-material/CorporateFareOutlined";
import WorkspacesOutlinedIcon from "@mui/icons-material/WorkspacesOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";

interface NotificationIconProps {
  notificationType: NotificationTypeJS;
}

export const NotificationIcon: React.FC<NotificationIconProps> = ({
  notificationType,
}) => {
  if (
    notificationType === NotificationTypeJS.ModelShared ||
    notificationType === NotificationTypeJS.ModelDeleted ||
    notificationType === NotificationTypeJS.AccessRevokedFromModel
  ) {
    return <DashboardOutlinedIcon className="icon-sm" />;
  }

  if (
    notificationType === NotificationTypeJS.TableShared ||
    notificationType === NotificationTypeJS.TableRequest ||
    notificationType === NotificationTypeJS.AccessRevokedFromTable ||
    notificationType === NotificationTypeJS.TableOwnershipTransferRequest ||
    notificationType === NotificationTypeJS.TableAccessResponse ||
    notificationType === NotificationTypeJS.TableOwnershipTransferResponse ||
    notificationType === NotificationTypeJS.TableScheduledForDeletion
  ) {
    return <TableChartOutlinedIcon className="icon-sm" />;
  }

  if (
    notificationType === NotificationTypeJS.OrgInvite ||
    notificationType === NotificationTypeJS.OrgAccessRevoked ||
    notificationType === NotificationTypeJS.OrgScheduledForDeletion ||
    notificationType === NotificationTypeJS.OrgOwnerGranted ||
    notificationType === NotificationTypeJS.OrgSoleOwner ||
    notificationType === NotificationTypeJS.OrgBillingAttention ||
    notificationType === NotificationTypeJS.OrgBillingPayerChanged
  ) {
    return <CorporateFareOutlinedIcon className="icon-sm" />;
  }

  if (notificationType === NotificationTypeJS.SpaceAccess) {
    return <FolderOutlinedIcon className="icon-sm" />;
  }
  if (
    notificationType === NotificationTypeJS.SpaceScheduledForDeletion ||
    notificationType === NotificationTypeJS.SpaceManagerNeeded
  ) {
    return <WorkspacesOutlinedIcon className="icon-sm" />;
  }

  return null;
};
